import './designSelect.scss';

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniq from 'utils/uniq';
import { Card, Typography, Form } from 'components/base';
import useWindowSize from 'components/hooks/useWindowSize';

const DesignSelect = props => {
  const [activeCategory, setActiveCategory] = useState();
  const [categories, setCategories] = useState([]);
  const { isMobile } = useWindowSize();

  useEffect(() => {
    const items = [];
    props.items.forEach(item => {
      if ('category' in item) {
        items.push(item.category);
      }
    });

    if (items.length > 1) {
      const activeItem = props.items.find(i => i.key === props.active);
      setCategories(uniq(items));
      setActiveCategory(activeItem.category);
    } else {
      setCategories([]);
      setActiveCategory(null);
    }
  }, [props.items, props.active]);

  const className = classNames({
    'p-0': true,
    [props.className]: props.className,
  });

  const handleOnItemClick = (e, key) => {
    e.preventDefault();

    props.onChange(key);
  };

  const handleOnCategoryClick = (e, category) => {
    e.preventDefault();

    setActiveCategory(category);
  };

  let items;
  if (categories.length > 1) {
    items = props.items.filter(i => i.category === activeCategory);
  } else {
    items = props.items;
  }

  return (
    <>
      {props.title && (
        <Typography.H4 className="text-center text-warning m-1">{props.title}</Typography.H4>
      )}
      {categories.length > 1 && (
        <>
          {isMobile ? (
            <Form.Select
              value={activeCategory}
              onChange={e => setActiveCategory(e.target.value)}
              className="mb-1 mw-480 mx-auto"
            >
              {categories.map(category => (
                <Form.SelectOption key={category} value={category}>
                  {category === '' ? 'Other' : category}
                </Form.SelectOption>
              ))}
            </Form.Select>
          ) : (
            <div className="design-select-wrapper">
              <div className="design-select design-category-select mb-1">
                {categories.map(category => {
                  const cardClassName = classNames({
                    'card-equalize': true,
                    active: category === activeCategory,
                  });

                  return (
                    <div key={category} className="design-select-item w-auto">
                      <Card
                        asLink
                        className={cardClassName}
                        onClick={e => handleOnCategoryClick(e, category)}
                      >
                        <Typography.H5 className="text-center mb-0">
                          {category === '' ? 'Other' : category}
                        </Typography.H5>
                      </Card>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}

      <div className="design-select-wrapper">
        <Card className={className}>
          <div className="design-select">
            {items.map(item => {
              const cardClassName = classNames({
                'card-equalize p-1': true,
                active: item.key === props.active,
              });

              return (
                <div key={item.key} className="design-select-item">
                  <Card
                    asLink
                    className={cardClassName}
                    onClick={e => handleOnItemClick(e, item.key)}
                  >
                    {item.title && (
                      <Typography.H5
                        className={classNames({
                          'text-center': true,
                          'mb-0': !item.icon,
                        })}
                      >
                        {item.title}
                      </Typography.H5>
                    )}
                    <Card.Body className="p-0">
                      {item.icon && (
                        <div className="text-center">
                          <img src={item.icon} alt="" style={{ maxWidth: '100px' }} />
                        </div>
                      )}
                      {item.preview}
                    </Card.Body>
                    {item.subTitle && (
                      <Card.Footer className="text-center">
                        <Typography.Span>{item.subTitle}</Typography.Span>
                      </Card.Footer>
                    )}
                  </Card>
                </div>
              );
            })}
          </div>
        </Card>
      </div>
    </>
  );
};

DesignSelect.propTypes = {
  title: PropTypes.string,
  active: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      icon: PropTypes.string,
      category: PropTypes.string,
      title: PropTypes.string,
      subTitle: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func,
  className: PropTypes.string,
};

DesignSelect.defaultProps = {
  items: [],
};

export default DesignSelect;
